import { BootstrapModule } from 'libs/core/src/lib/modules/bootstrap.module';
import { PipesModule } from './pipes/pipes.module';
import { DirectivesModule } from './directives/directives.module';
import { ComponentsModule } from './components/components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, BootstrapModule],
  exports: [BootstrapModule, ComponentsModule, DirectivesModule, PipesModule, FormsModule, ReactiveFormsModule]
})
export class SharedModule {}
